 import React, { useState } from "react";
import ApprovedFeedback from "./ApprovedFeedback";

import "./Feedback.css";
import { submitFeedback } from "../services/feedbackService";

const FeedbackContent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    rating: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await submitFeedback(formData);
      alert(response?.message || "Feedback submitted successfully!");
      setFormData({ name: "", email: "", rating: "", message: "" });
    } catch (error) {
      alert(error?.message || "Unable to submit feedback.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="feedback-container">
        <div className="feedback-card">
          <h1>Feedback Form</h1>

          <p className="subtitle">
            Share your experience with our awareness website
          </p>

          <form onSubmit={handleSubmit} className="feedback-form">
            <div className="input-group">
              <label>Full Name</label>

              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <label>Email Address</label>

              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <label>Rating</label>

              <select
                name="rating"
                value={formData.rating}
                onChange={handleChange}
                required
              >
                <option value="">Select Rating</option>
                <option value="5">⭐⭐⭐⭐⭐ Excellent</option>
                <option value="4">⭐⭐⭐⭐ Very Good</option>
                <option value="3">⭐⭐⭐ Good</option>
                <option value="2">⭐⭐ Fair</option>
                <option value="1">⭐ Poor</option>
              </select>
            </div>

            <div className="input-group">
              <label>Your Feedback</label>

              <textarea
                name="message"
                rows="5"
                placeholder="Write your feedback here (minimum 10 characters)..."
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit Feedback"}
            </button>
          </form>
        </div>

        <ApprovedFeedback />
      </div>
    </>
  );
};

export default FeedbackContent;